<style scoped lang="less">
  .qrcodepay-wrap {
    width: 582px;
    margin: 0 auto;
    .qrcode-wrap {
      float: left;
      margin-top: 36px;
      width: 249px;
      .qrcode {
        border: 1px solid #ccc;
        width: 246px;
      }
      .qr-guide-1 {
        width: 247px;
        height: 49px;
        margin-top: 10px;
      }
      .qr-guide-1-wxpay {
        background: url('../../assets/pay/wxpay_qr_guide_1.jpg') center center no-repeat;
      }
    }
    .qr-guide-2 {
      float: left;
      width: 313px;
      height: 385px;
      margin: 0 0 0 20px;
    }
    .qr-guide-2-wxpay {
      background: url('../../assets/pay/wxpay_qr_guide_2.jpg') center center no-repeat;
    }
  }
</style>
<template>
  <div class="qrcodepay-wrap">
    <div class="qrcode-wrap">
      <qriously class="qrcode" :value="applyResult" :size="200"></qriously>
      <div class="qr-guide-1 qr-guide-1-wxpay">
      </div>
    </div>
    <div class="qr-guide-2 qr-guide-2-wxpay">
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: "scan-pay",
  props: {
    applyResult: {
      type: String,
      default: ''
    },
    orderId: {
      type: String,
      default: ''
    },
    payMethod: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      timer: null
    }
  },
  computed: {
    ...mapState('payResult', ['result'])
  },
  watch: {
    result(newValue) {
      if (newValue === true) {
        clearInterval(this.timer)
        this.$router.push({
          name: 'pay-return', params: {
            payMethod: this.payMethod,
            id: this.orderId,
          }
        })
      }
    }
  },
  methods: {
    queryResult() {
      this.$store.dispatch('payResult/query', this.orderId)
    }
  },
  mounted() {
    this.timer = window.setInterval(() => {
      this.queryResult()
    },3000)
  }
}
</script>
